import { z } from 'zod';
export const booleanOptionsSchema = z.object({});
export const booleanCellSchema = z.boolean();
//# sourceMappingURL=boolean.js.map